import { Directive, ElementRef, Input, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[noUnsafeSpecial]'
})
export class NoUnsafeSpecialDirective {
  private el: HTMLInputElement;
  private regExp = new RegExp(/[<>"]/);

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener("keypress", ['$event']) onKeyPress(e: KeyboardEvent) {
    var char = String.fromCharCode(e.keyCode);
    if (this.regExp.test(char))
      return false
    else
      return true;
  }

  @HostListener("paste", ['$event']) onPaste(e: ClipboardEvent) {
    var input = e.clipboardData!.getData('text/plain');
    if (this.regExp.test(input))
      return false
    else
      return true;
  }
}
